import React from 'react'
import { SanityKeyDocumentsBlock } from '../../../../../types/generated/graphql-types'
import { mapSanityKeyDocumentsProps } from '../../../../mapping/KeyDocumentsMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { KeyDocuments } from '../../../blocks/KeyDocumentsBlock'
import { useSiteWideDisclaimer } from '../../../Disclaimer/SiteWide/useSiteWideDisclaimer'

export type AliasedKeyDocumentsBlock = SanityKeyDocumentsBlock & {
  tableRows?: SanityKeyDocumentsBlock['rows']
}

export type KeyDocumentsSerializerProps = AliasedKeyDocumentsBlock & BlockWithId

export const KeyDocumentsSerializer = ({ id, ...props }: KeyDocumentsSerializerProps) => {
  const { currentPagePublic, enabled } = useSiteWideDisclaimer()

  const siteWideDisclaimerEnabledForThisPage = !currentPagePublic && enabled

  return (
    <KeyDocuments
      {...mapSanityKeyDocumentsProps(props, siteWideDisclaimerEnabledForThisPage)}
      id={id}
    />
  )
}
